module.exports = __webpack_public_path__ + "img/7.c564dd2e.jpg";